import React, { useState } from 'react';
//import { useNavigate } from 'react-router-dom';
//import { showToast } from '../../contexts/ToastNotification';
import { OrderGroupingPanel } from './OrderGroupingPanel';
import useDashboardData from '../../components/hooks/hooks-admin/useDashboardData';
import { useOrderDetails } from '../../components/hooks/hooks-admin/useAdminOrders'
import './admin-orders.scss';

function AdminOrders() {
    const [showOrderDetail, setShowOrderDetail] = useState(false);
    
    const {
        orders,
        loading,
        filters,
        pagination,
        updateOrderStatus,
        applyFilters,
        resetFilters,
        changePage,
        formatCurrency,
        formatDate,
        isUpdatingOrder
    } = useDashboardData();
    
    const {
        selectedOrder,
        //loading: loadingDetail,
        fetchOrderDetail,
        resetSelectedOrder
    } = useOrderDetails();

    const orderStatuses = [
        { value: 'in_attesa', label: '📝 In attesa', color: '#f39c12', bg: '#fff3e0' },
        { value: 'in_elaborazione', label: '⚙️ In elaborazione', color: '#3498db', bg: '#e3f2fd' },
        { value: 'spedito', label: '🚚 Spedito', color: '#9b59b6', bg: '#f3e5f5' },
        { value: 'consegnato', label: '✅ Consegnato', color: '#27ae60', bg: '#e8f5e9' },
        { value: 'annullato', label: '❌ Annullato', color: '#e74c3c', bg: '#fdecea' }
    ];

    const handleViewDetails = async (orderId) => {
        const order = await fetchOrderDetail(orderId);
        if (order) {
            setShowOrderDetail(true);
        }
    };

    const handleCloseDetail = () => {
        setShowOrderDetail(false);
        resetSelectedOrder();
    };

    const getStatusDisplay = (status) => {
        return orderStatuses.find(s => s.value === status) || { label: status, color: '#6c757d', bg: '#e9ecef' };
    };

    if (loading && orders.length === 0) {
        return <div className="admin-loading">Caricamento ordini...</div>;
    }

    return (
        <div className="admin-orders">
            <div className="orders-header">
                <h2>📦 Gestione Ordini</h2>
                <p>Visualizza e gestisci tutti gli ordini del tuo e-commerce</p>
            </div>

            {/* PANNELLO RITIRI FORNITORI */}
            <OrderGroupingPanel />

            {/* FILTRI */}
            <div className="orders-filters">
                <input
                    type="text"
                    placeholder="Cerca per email o numero ordine..."
                    value={filters.search}
                    onChange={(e) => applyFilters({ search: e.target.value })}
                    className="search-input"
                />
                <select
                    value={filters.status}
                    onChange={(e) => applyFilters({ status: e.target.value })}
                    className="status-filter"
                >
                    <option value="">📊 Tutti gli stati</option>
                    {orderStatuses.map(s => (
                        <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                </select>
                <button onClick={resetFilters} className="reset-btn">Reset</button>
            </div>

            {/* TABELLA TUTTI GLI ORDINI */}
            <div className="orders-table-container">
                <table className="orders-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Cliente</th>
                            <th>Data</th>
                            <th>Totale</th>
                            <th>Pagamento</th>
                            <th>Stato</th>
                            <th>Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map(order => {
                            const statusDisplay = getStatusDisplay(order.stato);
                            return (
                                <tr key={order.id}>
                                    <td>#{order.numero_ordine || order.id}</td>
                                    <td>
                                        <strong>{order.cliente?.nome} {order.cliente?.cognome}</strong>
                                        <br/>
                                        <small>{order.cliente?.email}</small>
                                    </td>
                                    <td>{formatDate(order.data_creazione)}</td>
                                    <td>{formatCurrency(order.totale)}</td>
                                    <td>{order.metodo_pagamento || 'N/D'}</td>
                                    <td>
                                        <select
                                            value={order.stato}
                                            onChange={(e) => updateOrderStatus(order.id, e.target.value)}
                                            disabled={isUpdatingOrder(order.id)}
                                            style={{ backgroundColor: statusDisplay.bg, color: statusDisplay.color }}
                                        >
                                            {orderStatuses.map(s => (
                                                <option key={s.value} value={s.value}>{s.label}</option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <button onClick={() => handleViewDetails(order.id)} className="view-btn">
                                            👁️ Dettagli
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* PAGINAZIONE */}
            {pagination.totalPages > 1 && (
                <div className="pagination">
                    <button onClick={() => changePage(pagination.page - 1)} disabled={pagination.page === 1}>
                        ← Precedente
                    </button>
                    <span>Pagina {pagination.page} di {pagination.totalPages}</span>
                    <button onClick={() => changePage(pagination.page + 1)} disabled={pagination.page === pagination.totalPages}>
                        Successiva →
                    </button>
                </div>
            )}

            {/* MODAL DETTAGLIO */}
            {showOrderDetail && selectedOrder && (
                <div className="order-detail-modal-overlay" onClick={handleCloseDetail}>
                    <div className="order-detail-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Ordine #{selectedOrder.numero_ordine}</h3>
                            <button onClick={handleCloseDetail}>✕</button>
                        </div>
                        <div className="modal-body">
                            <div className="detail-section">
                                <h4>👤 Cliente</h4>
                                <p>{selectedOrder.cliente?.nome} {selectedOrder.cliente?.cognome}</p>
                                <p>{selectedOrder.cliente?.email}</p>
                            </div>
                            <div className="detail-section">
                                <h4>🛍️ Prodotti</h4>
                                {selectedOrder.items?.map((item, idx) => (
                                    <div key={idx} className="product-item">
                                        {item.nome} - x{item.quantita} = {formatCurrency(item.prezzo_totale)}
                                    </div>
                                ))}
                                <div className="total"><strong>Totale: {formatCurrency(selectedOrder.totale)}</strong></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export default AdminOrders;
